module.exports = __webpack_public_path__ + "static/1_section_bg-a8acb3dd7ded44ad6f57940c66824990.svg";